import React from 'react';
// Import image directly using ES import
import damImage from '../../../assets/images/dam.jpeg';

const HydrologicalModeling = () => {
    return (
        <div className="analysis-section">
            <div className="analysis-content">
                <h2>Hydrological Modeling</h2>
                <p>
                    Our Hydrological Modeling services transform high-resolution LiDAR data into sophisticated water flow and flood simulation models crucial for risk management, infrastructure planning, and environmental protection.
                </p>
                <p>
                    With centimeter-level accuracy, our hydrological analyses identify flow paths, delineate watersheds, and predict flood extents with unprecedented precision. From stormwater management design to flood risk mapping and dam safety assessments, our models capture the complex interactions between terrain, infrastructure, and water movement.
                </p>
                <p>
                    We integrate LiDAR-derived terrain models with hydrologic parameters to deliver customized simulations that support informed decision-making for flood mitigation, urban planning, environmental compliance, and climate adaptation. Our deliverables include detailed watershed boundaries, drainage networks, flood inundation maps, and hydraulic modeling inputs optimized for your specific project requirements.
                </p>
                <div className="analysis-features">
                    <span className="feature-item">Flood Risk Mapping</span>
                    <span className="feature-item">Watershed Delineation</span>
                    <span className="feature-item">Drainage Analysis</span>
                    <span className="feature-item">Hydrodynamic Modeling</span>
                    <span className="feature-item">Dam Break Simulations</span>
                </div>
            </div>
            <div className="analysis-image">
                <img src={damImage} alt="LiDAR Hydrological Modeling for Dam Infrastructure" />
            </div>
        </div>
    );
};

export default HydrologicalModeling;